// import BacktestService from '@/api/backtest.js';
/* eslint-disable */
import ProductService from '@/api/products/productsService.js';
import ValidationService from '@/api/validation/validationService';
import { Product } from '@/utils/product.js';

export const order = {
  namespaced: true,
  state: () => ({
    productList: [
      new Product(),
    ],
    targetMarkets: [],
    brandNames: [],
    registeredProducts: {},
    errorCodes: [],
  }),

  getters: {
    getErrorString: (state) => {
      return state.errorCodes;
    },
    getProductList(state) {
      return state.productList;
    },
    getTargetMarkets: (state) => (lang) => {
      return state.targetMarkets[lang];
    },
    getBrandNames: (state) => {
      return state.brandNames;
    },
    getListOfRegisteredProducts: (state) => {
      return Object.keys(state.registeredProducts.info)
    }
  },

  mutations: {
    SET_ERROR_CODES(state, payload) {
      state.errorCodes = payload;
    },
    SET_PRODUCT_LIST(state, payload) {
      state.productList = JSON.parse(JSON.stringify(payload));
    },

    CLEAN_PRODUCT_LIST(state) {
      state.productList = [new Product()];
    },
    CLEAN_REGISTERED_LIST(state) {
      state.registeredProducts = {};
    },
    REMOVE_REGISTERED_PRODUCT(state, payload) {
      if(state.registeredProducts && state.registeredProducts.info && state.registeredProducts.info[payload]){
        delete state.registeredProducts.info[payload];
      }
    },

    SET_PRODUCT_MARKETS_LIST(state, payload) {
      state.targetMarkets = JSON.parse(JSON.stringify(payload));
    },

    SET_BRAND_NAMES_LIST(state, payload) {
      state.brandNames = JSON.parse(JSON.stringify(payload));
    },

    SET_REGISTERED_LIST(state, payload){
      state.registeredProducts = JSON.parse(JSON.stringify(payload));
    },

    ADD_PRODUCT(state, payload) {
      state.productList.push(payload);
    }
    
  },

  actions: {
    async getErrorCodes({ commit }) {
      try {
        const res = await ValidationService.getErrorCodes();
        commit('SET_ERROR_CODES', res.data);
      } catch (e) {
        console.log('GET ERROR CODES', e);
      }
    },
    updateProductList({ commit }, list) {
      commit('SET_PRODUCT_LIST', list);
    },
    addProduct({ commit }) {
      commit('ADD_PRODUCT', new Product());
    },

    cleanProductList({ commit }) {
      commit('CLEAN_PRODUCT_LIST');
    },
    cleanRegisteredList({ commit }) {
      commit('CLEAN_REGISTERED_LIST');
    },
    removeRegisteredProduct({ commit }, payload) {
      commit('REMOVE_REGISTERED_PRODUCT', payload);
    },
    registeredProducts({ commit }, list) {
      commit('SET_REGISTERED_LIST', list);
    },

    async getMarkets({ commit }) {
      try {
        const res = await ProductService.getMarkets();
        commit('SET_PRODUCT_MARKETS_LIST', res.data);
      } catch (e) {
        console.log('GET MARKETS', e);
      }
    },

    async getBrandNames({ commit }) {
      try {
        const res = await ProductService.getBrands();
        commit('SET_BRAND_NAMES_LIST', res.data);
      } catch (e) {
        console.log('GET BRANDNAMES', e);
      }
    }
  }
};
